module.exports = __webpack_public_path__ + "d24f60deb0049b0421ee39490cf71d3b.ttf";